import { Suspense } from 'react';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { PcmpProjectEditPage } from '@/features/pcmp/pages/PcmpProjectEditPage';

export const Route = createFileRoute('/_auth/pcmp/projects/$projectId/edit')({
  parseParams: ({ projectId }) => {
    const parsedId = Number(projectId);
    if (!Number.isInteger(parsedId) || parsedId <= 0) throw notFound();
    return { projectId: parsedId };
  },
  component: () => (
    <ErrorBoundary moduleName="Edit PCMP Project">
      <Suspense fallback={<PageLoader />}>
        <PcmpProjectEditPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
